/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RateRule
 */
export interface RateRule {
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'binSponsor'?: RateRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateRule
     */
    'creditOrPrepaid'?: RateRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateRule
     */
    'minimumTotalAmount': number;
}

export const RateRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateRuleBinSponsorEnum = typeof RateRuleBinSponsorEnum[keyof typeof RateRuleBinSponsorEnum];
export const RateRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateRuleCreditOrPrepaidEnum = typeof RateRuleCreditOrPrepaidEnum[keyof typeof RateRuleCreditOrPrepaidEnum];


